import React, { useState, useEffect, Component } from "react"
import CollegeProfile from "../College/CollegeProfile"
import Spinner from "../../Components/Spinner/Spinner"
import CollegeHomeContainer from "../Container/CollegeHomeContainer"
import UploadLogo from "./UploadLogo";

//Yuan-redux
import { connect } from "react-redux"
import { updateInstLogo, updateInstTagline, updateInstWebsite } from "../../redux/college/college.actions"

//Jiazheng: redux store
import { API } from "../../API"
import Auth from "../../Auth/Auth"
import { permIndices } from "../../Permissions"

const CollegeHome = (props) => {
    const { updateInstLogo, user, updateInstTagline, 
        updateInstWebsite, viewbookings, campuses, personnel, institution } = props

    const [isUploadPopup, setIsUploadPopup] = useState(false)
    const [isAbleToEdit, setIsAbleToEdit] = useState(false)
    const [qualificationList, setQualificationList] = useState([])
    const [selectedList, setSelectedList] = useState({})
    const [institutionData, setInsitutionData] = useState(institution)
    const [selectedCanDelivers, setSelectedCanDelivers] = useState(institution.selected_can_delivers)
    const [selectedByQualification, setSelectedByQualification] = useState({})
    const [roomsAndProgramsList, setRoomsAndProgramsList] = useState([])
    const [selectedRoomsPrograms, setSelectedRoomsPrograms] = useState(institution?.selected_rooms_programs)
    const [selectedRoomsProgramsQual, setSelectedRoomsProgramsQual] = useState([])
    const [isLoading, setIsLoading] = useState(true);

    const tabs = [
        (user.permissions == 0) ?
            {
                pathname: '/PersonnelDashboard',
                text: "Dashboard",
            } : {
                pathname: '/CollegeDashboard',
                text: "Dashboard",
            },
        {
            pathname: '/profile',
            text: user?.is_childcare_centre ? "Centre Profile" : "Institute Profile",
            active: true,
        },
    ]

    useEffect(async () => {
        setInsitutionData(institution)
    }, [institution])
    
    useEffect(() => {
        if (user === null) {
            window.location = "/loginAsInstitution";
        }
        Auth.authCheck(1 << permIndices.ed_col)
            .then(async (res) => {
                setIsAbleToEdit(res.authenticated)

                const result = await API.getInstitutionData({
                    ...institution,
                    id: institution._id
                })
                const newInstitution = result?.data
                setInsitutionData(newInstitution)

                API.getQualificationList().then(result => {
                    const qualifications = result?.data?.data
                    setQualificationList(qualifications)

                    // check selectedList
                    const { selected_can_delivers, selected_rooms_programs = [] } = newInstitution
                    const selectedCanDeliverIDs = selected_can_delivers
                    setSelectedCanDelivers(selected_can_delivers)
                    setSelectedRoomsPrograms(selected_rooms_programs)
                        // .map(item => item.split("_id:")?.[1])
                        // .filter(item => item)
                    const selectedItem = {}
                    const selectedByQualification = {}
                    const ececRoomsAndProgramsList = []
                    const ececSelectedRoomsProgramsQual = []
                    qualifications.forEach(item => {
                        const quaList = item.qualifications
                        if(item.type === 'vet') {
                            quaList.forEach(qua => {
                                const { units } = qua
                                units.forEach(unit => {
                                    if(selected_can_delivers.includes(unit._id)) {
                                        const key = `${qua.title}_keyID:${qua._id}`
                                        const unitItem = `${unit.title}_id:${unit._id}`
                                        if(selectedItem[key]?.length) {
                                            if(!selectedItem[key]?.includes(unitItem)) {
                                                selectedItem[key].push(unitItem)
                                            }
                                        }
                                        else {
                                            selectedItem[key] = [unitItem]
                                        }

                                        if(selectedByQualification[qua._id]?.length) {
                                            selectedByQualification[qua._id].push(unit._id)
                                        }
                                        else {
                                            selectedByQualification[qua._id] = [unit._id]
                                        }
                                    }
                                })
                            })
                        }
                        else {
                            const key = `${item.qualification_name}_keyID:${item._id}`
                            quaList.forEach(qua => {
                                const quaItem = `${qua.title}_id:${qua._id}`
                                if(selected_can_delivers.includes(qua._id)) {
                                    if(selectedItem[key]?.length) {
                                        if(!selectedItem[key]?.includes(quaItem)) {
                                            selectedItem[key].push(quaItem)
                                        }
                                    }
                                    else {
                                        selectedItem[key] = [quaItem]
                                    }
                                }
                            })
                        }

                        if (user?.is_childcare_centre && item.type === 'ecec') {
                            ececRoomsAndProgramsList.push(item)
                            quaList.forEach((qua => {
                                if (selected_rooms_programs.includes(qua._id)) {
                                    ececSelectedRoomsProgramsQual.push(qua)
                                }
                            }))
                        }
                    })
                    setIsLoading(false);
                    setSelectedList(selectedItem)
                    setSelectedByQualification(selectedByQualification)
                    setRoomsAndProgramsList(ececRoomsAndProgramsList)
                    setSelectedRoomsProgramsQual(ececSelectedRoomsProgramsQual)
                })
            })
    }, [])

    //upload avatar function
    const toggleUpload = (e) => {
        setIsUploadPopup(true)
    }

    const closeUpload = (e) => {
        setIsUploadPopup(false)
    }

    // update this
    const updatelogo = (inst_id, suffix) => {
        updateInstLogo(inst_id, suffix)
    }
    
    return (
        !isLoading ? <CollegeHomeContainer
            user={user}
            institution={institutionData}
            tabs={tabs}
            isViewAsCollege={true}
            isAbleToEdit={isAbleToEdit}
            isShowUploadAvatar={true}
            tabProfileActive={false}
            uploadAvatar={toggleUpload}
            updateTagline={(e) => updateInstTagline(e)}
            updateWebsiteURL={(e) => updateInstWebsite(e)}
            offset={true}
            viewbookings={viewbookings}
            showShareButton
            removeTopMargin={true}
        >

            {isUploadPopup && (
                <UploadLogo
                    closePopup={closeUpload}
                    // newUser={newUser}
                    // setInst={setInst}
                    inst={props.institution._id}
                    user={user}
                    updatelogo={updatelogo}
                    // updateUser={this.state.user}
                />
            )}

            { qualificationList?.length && <CollegeProfile
                isAbleToEdit={isAbleToEdit}
                institution={institutionData}
                campuses={campuses}
                personnels={personnel}
                user={user}
                isViewAsCollege={true}
                selectedItem={selectedList}
                selectedCanDelivers={selectedCanDelivers}
                qualifications={qualificationList}
                selectedByQualification={selectedByQualification}
                roomsAndProgramsList={roomsAndProgramsList}
                selectedRoomsPrograms={selectedRoomsPrograms}
                selectedRoomsProgramsQual={selectedRoomsProgramsQual}
            />}
        </CollegeHomeContainer>
        : (<Spinner />)
    )
}

const mapStateToProps = (state) => {
    return {
        user: state.college.user,
        institution: state.college.institution,
        campuses: state.college.campuses,
        personnel: state.college.personnel,
        viewbookings: (state.college.user.permissions) ? state.college.user.permissions & (1 << permIndices.vi_book) : 1,
    }
}

const mapDispatchToProps = (dispatch) => ({
    updateInstLogo: (inst_id,suffix) => dispatch(updateInstLogo(inst_id,suffix)),
    updateInstTagline: (tagline) => dispatch(updateInstTagline(tagline)),
    updateInstWebsite: (url) => dispatch(updateInstWebsite(url))
})

export default connect(mapStateToProps, mapDispatchToProps)(CollegeHome)
